import {ChevronLeft, ChevronRight} from "lucide-react";
import {useTranslation} from "../../../shared/i18n";


const PAGE_SIZE = 20;

export const ServerPagination = ({
    page,
    count,
    next,
    previous,
    busy,
    onPageChange,
}) => {
    const {t} = useTranslation();
    const start = count === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
    const end = Math.min(page * PAGE_SIZE, count);

    return (
        <nav
            className="onboarding-pagination"
            aria-label={t("sections.onboarding.p194")}
            aria-busy={busy}
        >
            <p className="onboarding-pagination-range">
                {t("sections.onboarding.p195")} {start}-{end} {t("sections.onboarding.p196")} {count}
            </p>
            <p className="onboarding-pagination-page" aria-live="polite">
                {t("sections.onboarding.p197")} {page}
            </p>
            <div className="onboarding-pagination-actions">
                <button
                    className="admin-button admin-button-secondary"
                    type="button"
                    disabled={busy || previous === null}
                    onClick={() => onPageChange(previous)}
                >
                    <ChevronLeft aria-hidden="true" size={16} />
                    {t("sections.onboarding.p198")}
                </button>
                <button
                    className="admin-button admin-button-secondary"
                    type="button"
                    disabled={busy || next === null}
                    onClick={() => onPageChange(next)}
                >
                    {t("sections.onboarding.p199")}
                    <ChevronRight aria-hidden="true" size={16} />
                </button>
            </div>
        </nav>
    );
};
